import { Directive, ElementRef, HostListener, Input, OnInit } from '@angular/core';

@Directive({
    selector: 'input[numbersonly], [numbersonly]',
})
export class NumbersOnlyDirective implements OnInit {
    @Input() maxlength: string | number;

    constructor(private _el: ElementRef) { }

    ngOnInit() {
        const input = this.getInputElement();
        if (input && this.maxlength) {
            input.setAttribute('maxlength', String(this.maxlength));
        }
    }

    private getInputElement(): HTMLInputElement | null {
        if (this._el.nativeElement.tagName === 'INPUT') {
            return this._el.nativeElement;
        }
        return this._el.nativeElement.querySelector('input');
    }

    @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent) {
        const input = this.getInputElement();
        if (!input) return;
        const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'];
        if (allowedKeys.includes(event.key) || event.ctrlKey || event.metaKey) {
            return;
        }
        if (!/^[0-9]$/.test(event.key)) {
            event.preventDefault();
            return;
        }
        const max = Number(this.maxlength || input.getAttribute('maxlength'));
        if (max && input.value && input.value.length >= max && input.selectionStart === input.selectionEnd) {
            event.preventDefault();
        }
    }

    @HostListener('input', ['$event']) onInputChange(event) {
        const input = this.getInputElement();
        if (!input) return;
        const initialValue = input.value;
        let cleaned = (initialValue || '').replace(/[^0-9]*/g, '');
        const max = Number(this.maxlength || input.getAttribute('maxlength'));
        if (max && cleaned.length > max) {
            cleaned = cleaned.slice(0, max);
        }
        input.value = cleaned;
        if (initialValue !== cleaned) {
            event.stopPropagation();
        }
    }
}
